export const getPromoUrl = (): string => window.settings.config.promo_news_active > 0
    ? '/promotions'
    : '/promotions_old';
